import React, { useCallback, useEffect, useState } from 'react'
import { couponOrigin, promotionOriginType } from 'shared/utils'
import type { Coupon } from 'shared/types'
import { processCouponNavigation } from 'shared/store/ecommerce/order'
import { useDispatch, useSelector } from 'react-redux'
import { catalogType, promoType } from 'shared/utils'
import { eventMetadata } from 'shared/store/metadata'
import { SelectionScreenModal } from './SelectionScreenModal'
import { push } from 'connected-react-router'
import { useIntl } from 'react-intl'

const { IMPERSONAL_COUPON, KINGDOM_POINTS } = couponOrigin
const { COMMON } = promotionOriginType

type NextScreenHandlerProps = {
    coupon: ?Coupon
}
const { MENU, PRODUCT } = catalogType

export const NextPromotionScreenHandler = ({
    coupon
}: NextScreenHandlerProps) => {
    const d = useDispatch()
    const intl = useIntl()
    const { promotionId } = coupon || {}
    const promotion = useSelector(s =>
        promotionId
            ? s.ecommerceCatalogState.promotionsById[promotionId]
            : undefined
    )
    const [selectionScreenInfos, setSelectionScreenInfos] = useState(undefined)
    const handleRedirect = useCallback(async () => {
        const { id: couponCode, promotionId, origin } = coupon || {}
        const isImpersonalOperation = origin === IMPERSONAL_COUPON
        let errorMessage, route
        if (promotion && coupon) {
            const CCpromo = {
                couponCode,
                idReboot: promotion.idReboot,
                promoType: promotion.promoType,
                promoValue: promotion.promoValue || 0,
                promotionId,
                promotionName: promotion.name,
                threshold: promotion.threshold
            }
            const promotionOrigin =
                origin === KINGDOM_POINTS ? undefined : COMMON
            const {
                listItems,
                type,
                isDeliveryFeesPromotion,
                hasOptions
            } = await d(processCouponNavigation(coupon, promotion))
            if (listItems && type) {
                //$FlowFixMe
                setSelectionScreenInfos({
                    listItems,
                    promotion: CCpromo,
                    type,
                    promotionOrigin,
                    isImpersonalOperation
                })
                return
            } else {
                switch (type) {
                    case MENU:
                        route = 'routes.clickandcollect.menu'
                        break
                    case PRODUCT:
                        route = hasOptions
                            ? 'routes.clickandcollect.product'
                            : 'routes.clickandcollect.catalog'
                        break
                    case promoType.ORDER:
                        route = 'routes.clickandcollect.cart.summary'
                        break
                    default:
                        break
                }

                const promotionOrigin =
                    origin === KINGDOM_POINTS ? undefined : COMMON

                if (route) {
                    eventMetadata(CCpromo)
                    d(
                        push(
                            intl.formatMessage({
                                id: route
                            }),
                            {
                                promotion: CCpromo,
                                promotionOrigin
                            }
                        )
                    )
                }
            }
        }
    }, [coupon, d, promotion])

    useEffect(() => {
        //$FlowFixMe
        handleRedirect()
    }, [coupon, handleRedirect, promotion])

    return (
        <SelectionScreenModal
            selectionScreenInfos={selectionScreenInfos}
            displaySelectionScreen={selectionScreenInfos ? true : false}
            selectedCoupon={coupon}
        />
    )
}
